export default __webpack_public_path__ + "static/media/LACI.ebf10648.svg";